/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Determines whether to use "A" or "An" based on the following word.
 *
 * @param {String} word The word to analyze.
 * @example
 *
 * pickPrefix('apple');
 * // -> 'An'
 *
 * pickPrefix('banana');
 * // -> 'A'
 *
 * pickPrefix('hour');
 * // -> 'An'
 *
 */

const pickPrefix = (word) => {
  // Ensure the word is a string and trim any extra spaces
  if (typeof word !== 'string' || word.length === 0) {
    return '';
  }
  word = word.trim().toLowerCase();

  // List of vowels to check against
  const vowels = ['a', 'e', 'i', 'o', 'u'];

  // Special cases where the prefix should be "An"
  const specialCases = ['hour', 'honest', 'honor', 'heir'];

  // Check if the word is in the special cases list
  if (specialCases.includes(word)) {
    return 'An';
  }

  // Check if the word starts with a vowel
  if (vowels.includes(word.charAt(0))) {
    return 'An';
  }

  // Default to "A"
  return 'A';
};

export default pickPrefix;
